<template>
  <h1>{{ statusText }}</h1>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  data () {
    return {
      statusText: 'Avregistrerar...'
    }
  },

  methods: {
    ...mapActions('userSettings', ['unsubscribeFromWorkOrderUpdates'])
  },

  created () {
    this.unsubscribeFromWorkOrderUpdates(this.$route.params.code)
      .then(() => {
        this.statusText = 'Du är nu avregistrerad'
      })
      .catch(() => {
        this.statusText = 'Något gick fel. Logga in och avregistrera dig under inställningar istället.'
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/UnsubscribeFromWorkOrderUpdatesPage.vue